<template>
  <div>
    <div class="b-banner-con">
      <v-header></v-header>
      <v-nav></v-nav>
    </div>
    <v-breadcrumb></v-breadcrumb>
    <!-- 主题内容 -->
    <div class="b-center-container">
      <!-- 富文本 -->
      <div class="b-container">
        <div class="b-center-main">
          <div class="b-richtext">
            <p v-html="richText"></p>
          </div>
        </div>
      </div>
    </div>
    <v-contact></v-contact>
      <!--
      <v-footer></v-footer>
      <v-copy></v-copy>
      -->
  </div>
</template>
<script>
/* eslint-disable */
import Header from "@/components/header/";
import Nav from "@/components/nav/";
import Copy from "@/components/copy/"
import Breadcrumb from "@/components/breadcrumb/"
import Footer from "@/components/footer/"
import Contact from "@/components/contact/";
export default {
  data () {
    return {
      richText: '',
    };
  },
  mounted () {
    this.richText = '<p style="text-align: left; "><span style="font-size: 22px; border-bottom: solid 3px #033d80;">访问学者</span></p>'

      + '<p style="margin-top : 20px; margin-bottom : 20px"><span style="margin-left: 36px; font-size: 16px;">经教育部批准，转化医学国家重大科技基础设施（上海）实施访问学者计划，旨在充分发挥转化医学设施的人才集聚与培养效能，鼓励国内外相关领域优秀学者和研究人员，利用设施平台开展学术交流和研究工作。访问学者在合作导师研究团队承担一定的科研任务，并制定具有战略性、前瞻性和创造性的发展目标、规划和实施方案。</span></p>'
      + '<p style="margin-bottom : 20px"><span style="margin-left: 36px; font-size: 16px;">2020年，经“转化医学国家重大科技基础设施（上海）访问学者计划”专家委员会审查，批准2020年访学学者计划立项共计3项。</span></p>'

      + '<p style="margin-bottom : 10px"><span style="margin-left: 36px; font-size: 16px; font-weight: bold">联系方式：</span></p>'
      + '<p style="margin-bottom : 10px"><span style="margin-left: 36px; font-size: 16px;">联 系 人：陈老师</span></p>'
      + '<p style="margin-bottom : 10px"><span style="margin-left: 36px; font-size: 16px;">联系电话：13472781726</span></p>'
      + '<p style="margin-bottom : 10px"><span style="margin-left: 36px; font-size: 16px;">联系地址：上海市闵行区东川路800号转化医学楼4楼C4办公区</span></p>'
      + '<p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>'


    //+'<p style="margin-bottom : 20px; text-align: center"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/gxsys2.png" style="width: 780px; margin-right: 16px;margin-bottom: 16px;" width="960px"  border="0" vspace="0" alt=""></p>'

  },
  components: {
    "v-header": Header,
    "v-nav": Nav,
    "v-copy": Copy,
    "v-breadcrumb": Breadcrumb,
    "v-footer": Footer,
    "v-contact": Contact,
  }
};
</script>
<style lang="scss">
  @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
    .b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
    }
  }
.b-richtext {
  text-align:left;
  b,
  strong {
    font-weight: 700;
  }
  p {
    margin: 0 0 10px;
  }
  line-height: 32px;
}
</style>



// WEBPACK FOOTER //
// src/pages/visitor/index.vue